export class TlaNotFoundError extends Error {
	override name = 'TlaNotFoundError'
	constructor() {
		super()
	}
}
